'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function PoolVsOceanPage() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen py-6 xxs:py-3 px-4 xxs:px-2 ${
      theme === 'light'
        ? 'bg-gradient-to-b from-blue-50 to-white'
        : 'bg-gradient-to-b from-gray-900 to-gray-800'
    }`}>
      <div className="max-w-4xl mx-auto">
        <Link href="/guide" className={`hover:underline mb-3 xxs:mb-2 inline-block text-sm xxs:text-xs ${
          theme === 'light' ? 'text-blue-600' : 'text-blue-400'
        }`}>
          ← 입문 가이드 목록
        </Link>

        <article className={`rounded-lg shadow-xl p-6 xxs:p-3 ${
          theme === 'light' ? 'bg-white' : 'bg-gray-800'
        }`}>
          <h1 className={`text-2xl xxs:text-lg font-bold mb-4 xxs:mb-3 ${
            theme === 'light' ? 'text-gray-900' : 'text-white'
          }`}>풀다이빙 vs 바다다이빙</h1>

          <div className="max-w-none">
            <p className={`text-sm xxs:text-xs mb-4 xxs:mb-3 ${
              theme === 'light' ? 'text-gray-600' : 'text-gray-400'
            }`}>
              풀다이빙과 바다다이빙의 차이점과 각각의 장단점을 알아보세요.
            </p>

            <div className="grid md:grid-cols-2 xxs:grid-cols-1 gap-4 xxs:gap-3 mt-6 xxs:mt-4">
              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h2 className={`text-base xxs:text-sm font-bold mb-3 xxs:mb-2 ${
                  theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                }`}>🏊 풀다이빙</h2>

                <h3 className={`font-bold text-sm xxs:text-xs mt-3 xxs:mt-2 mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>장점</h3>
                <ul className={`space-y-1.5 xxs:space-y-1 text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  <li>✅ 통제된 환경에서 안전하게 연습</li>
                  <li>✅ 날씨에 영향 받지 않음</li>
                  <li>✅ 접근성이 좋음 (도심 인근)</li>
                  <li>✅ 초보자에게 이상적</li>
                  <li>✅ 테크닉 연습에 집중 가능</li>
                  <li>✅ 일년 내내 이용 가능</li>
                </ul>

                <h3 className={`font-bold text-sm xxs:text-xs mt-3 xxs:mt-2 mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>단점</h3>
                <ul className={`space-y-1.5 xxs:space-y-1 text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  <li>❌ 제한된 수심 (최대 35m)</li>
                  <li>❌ 단조로운 환경</li>
                  <li>❌ 해양 생물 관찰 불가</li>
                  <li>❌ 입장료 부담</li>
                </ul>

                <div className={`mt-3 xxs:mt-2 p-3 xxs:p-2 rounded ${
                  theme === 'light' ? 'bg-white' : 'bg-gray-800'
                }`}>
                  <p className={`text-xs xxs:text-[10px] ${
                    theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                  }`}>
                    <strong>추천 대상:</strong> 초보자, 테크닉 연습, 트레이닝
                  </p>
                </div>
              </div>

              <div className={`p-4 xxs:p-3 rounded-lg ${
                theme === 'light' ? 'bg-blue-50' : 'bg-blue-900/20'
              }`}>
                <h2 className={`text-base xxs:text-sm font-bold mb-3 xxs:mb-2 ${
                  theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                }`}>🌊 바다다이빙</h2>

                <h3 className={`font-bold text-sm xxs:text-xs mt-3 xxs:mt-2 mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>장점</h3>
                <ul className={`space-y-1.5 xxs:space-y-1 text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  <li>✅ 무한한 수심과 공간</li>
                  <li>✅ 아름다운 해양 생물 관찰</li>
                  <li>✅ 자연과의 교감</li>
                  <li>✅ 다양한 다이빙 포인트</li>
                  <li>✅ 진정한 프리다이빙 경험</li>
                  <li>✅ 입장료 없음 (자유롭게)</li>
                </ul>

                <h3 className={`font-bold text-sm xxs:text-xs mt-3 xxs:mt-2 mb-2 xxs:mb-1.5 ${
                  theme === 'light' ? 'text-gray-900' : 'text-white'
                }`}>단점</h3>
                <ul className={`space-y-1.5 xxs:space-y-1 text-xs xxs:text-[10px] ${
                  theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                }`}>
                  <li>❌ 날씨와 파도 영향</li>
                  <li>❌ 접근성 (이동 시간)</li>
                  <li>❌ 조류와 수온 변화</li>
                  <li>❌ 안전 관리 필요</li>
                  <li>❌ 경험 필요 (중급 이상)</li>
                </ul>

                <div className={`mt-3 xxs:mt-2 p-3 xxs:p-2 rounded ${
                  theme === 'light' ? 'bg-white' : 'bg-gray-800'
                }`}>
                  <p className={`text-xs xxs:text-[10px] ${
                    theme === 'light' ? 'text-gray-600' : 'text-gray-400'
                  }`}>
                    <strong>추천 대상:</strong> 중급 이상, 자연 체험, 레저
                  </p>
                </div>
              </div>
            </div>

            <div className={`mt-6 xxs:mt-4 p-4 xxs:p-3 rounded-lg ${
              theme === 'light' ? 'bg-yellow-50' : 'bg-yellow-900/20'
            }`}>
              <h3 className={`font-bold text-base xxs:text-sm mb-2 xxs:mb-1.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>💡 추천 학습 경로</h3>
              <div className={`space-y-2 xxs:space-y-1.5 text-xs xxs:text-[10px] ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>
                <div className="flex items-center">
                  <span className={`font-bold mr-2 xxs:mr-1.5 ${
                    theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                  }`}>1단계</span>
                  <span>풀다이빙으로 기본기 습득 (AIDA 1-2)</span>
                </div>
                <div className="flex items-center">
                  <span className={`font-bold mr-2 xxs:mr-1.5 ${
                    theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                  }`}>2단계</span>
                  <span>풀에서 충분히 연습 (3-6개월)</span>
                </div>
                <div className="flex items-center">
                  <span className={`font-bold mr-2 xxs:mr-1.5 ${
                    theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                  }`}>3단계</span>
                  <span>경험자와 함께 바다 체험</span>
                </div>
                <div className="flex items-center">
                  <span className={`font-bold mr-2 xxs:mr-1.5 ${
                    theme === 'light' ? 'text-blue-600' : 'text-blue-400'
                  }`}>4단계</span>
                  <span>바다 환경 적응 및 고급 자격증 취득</span>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 xxs:grid-cols-1 gap-3 xxs:gap-2 mt-6 xxs:mt-4">
              <Link
                href="/map"
                className="block p-4 xxs:p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center"
              >
                <h3 className={`font-bold mb-1.5 xxs:mb-1 text-base xxs:text-sm ${
                  theme === 'light' ? 'text-white' : 'text-white'
                }`}>🏊 풀다이빙 시작하기</h3>
                <p className="text-xs xxs:text-[10px]">전국 다이빙풀 찾기</p>
              </Link>
              <Link
                href="/map"
                className="block p-4 xxs:p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center"
              >
                <h3 className={`font-bold mb-1.5 xxs:mb-1 text-base xxs:text-sm ${
                  theme === 'light' ? 'text-white' : 'text-white'
                }`}>🌊 바다 포인트 탐색</h3>
                <p className="text-xs xxs:text-[10px]">전국 바다 다이빙 포인트</p>
              </Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  )
}
